import { observable, action } from 'mobx';

export default class SearchStore {
  @observable requests = {};
  @observable results = {};

  @action
  search(url, queryString) {
    if (this.requests[queryString] === undefined) {
      this.requests[queryString] = $.ajax({ url, data: { q: queryString } }).then((results) => {
        this.results[queryString] = results;
        return results;
      });
    }
    return this.requests[queryString];
  }
}
